module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/205-switzerland-82698ec1aea4e554ff5562f5cbfc6a74.svg";